<template>
  <div>
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :fixed="false" :title="$route.name" style="background:#BF0000; height:40px; padding-top:5px; padding-bottom:15px; color:#fff">

      <template #right>
        <router-link to="/caridetay">
          <van-button size="small" round color="linear-gradient(to right, red, red)">
            {{ unvanCreate()  }} 
          </van-button>
        </router-link>
      
        <router-link to="/">
          <van-icon name="envelop-o" dot/>
        </router-link>
      </template>

    </van-nav-bar>
    <van-notice-bar v-if= "!$store.getters.getCari.aktif.unvan" :scrollable="false" color="#1989fa" background="#ecf9ff" left-icon="info-o">
Müşteri Seçilmemiş.</van-notice-bar>
  </van-sticky>
  </div>
</template>
<script>

export default {
  props: {},
  data () {
    return {
      unvan:'HA'
    }
  },
 methods: {
  unvanCreate(){
      if (this.$store.getters.getCari.aktif.unvan) {
        let kisa=this.$store.getters.getCari.aktif.unvan.split(" ");
        if (kisa.length>1) {
          return kisa[0].substring(0,1)+kisa[1].substring(0,1)
        }
        else {
          return this.$store.getters.getCari.aktif.unvan.substring(0,2)
        }
      }
      else {
        return "XX"
      }
    },
    onClickLeft() {
     window.history.back();
    //this.$route.go("/hesap")
    },
  },  
};
</script>
<style>
.van-cell{
  background:#f1f3f5 !important;
  margin:5px auto 5px auto;
  border-radius: 5px;
}
.van-cell__right-icon,.van-icon-down,.van-icon-apps-o,.van-icon-cluster-o,.van-icon-home-o,.van-icon-manager-o,.van-icon-plus,.van-icon-user-circle-o,.van-icon-upgrade,.van-icon-left-arrow,.van-popup__close-icon,.van-icon-friends-o, .van-icon-coupon-o, .van-icon-notes-o{
  color:#484848 !important;
  font-size:26px !important;
};
.van-cell__title{
  font-size: 16px;
  margin-left: 5px;
}
.van-icon-envelop-o {font-size:28px !important; color:white !important; margin-left:15px; margin-top: 5px; margin-right:0 !important}
.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: #fff !important;
    font-weight: 500;
    font-size: 0.426667rem;
}
</style>


// WEBPACK FOOTER //
// src/components/headers.vue